export default __webpack_public_path__ + "media/img_03/300@2x-023437f6.jpg";